import React from "react";
import {
  // HiXCircle,
  ImCancelCircle,
  // MdSkipPrevious,
  // MdExitToApp
} from "react-icons/im";
import { useTranslation } from "react-i18next";

export default function CancelButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button  is-small modal-button ${
          props.disabled ? "button-disabled" : ""
        } ${
          props.shouldShowButtonLabels ? " show-label-top-menu " : ""
          }`}
        onClick={props.onClickHandler}
        title={t("Cancel")}
      >
        <span className="icon  has-text-danger">
          <ImCancelCircle className="fas fa-2x" />
        </span>
        {props.shouldShowButtonLabels && <span className="has-text-danger mr-2 show-label-text">{t("Cancel")}</span>}
      </button>
    </>
  );
}
